var sustainableBeauty = {
    init: function(){
        this.villageStripe();
    },    
    villageStripe: function () {

        if($(window).width() <= 798) return;
    
        var $el = $('.village-stripe-env:not(.bg-image)'),
            $clone = $el.clone().addClass('sticky-bottom'),
            elHeight = $el.outerHeight();
    
            $clone.insertAfter($el);
    
            $('body').css({'paddingBottom':elHeight});
    
            $el.waypoint(function(direction) {
    
                $clone.toggleClass('visible',(direction=='down'));
    
            }, {
                offset: (elHeight*-1)
            });
    }
}


//document ready
$(function() {

    sustainableBeauty.init();

});
